window.imark = imark;

import '../../src/index'

import "./../icons/symbols.js"
import "./general/a-accessible-bundle.js"
import "./general/a-lib.js"
import "./general/a-lazyload.js"
import "./general/a-sections-menu.js"
import "./general/a-popup.js"
import "./m-articles-list.js" 

import "./l-header.js"
import "./l-page-desc.js"
import "./l-dashboard.js"

import "./m-intro.js"
import "./m-faq.js"

import "./c-effects.c-decorations.js"
import "./c-paginate-category"

import "./a-accessibility.js"

var main = new Main();
lib.run_all(main);

// contact form 7 spinner
(function($) {
  $('.wpcf7').on('wpcf7:beforesubmit', function(e) {
    $(this).find('[type="submit"]').parent('label').addClass('loading')
  }).on('wpcf7:submit', function() {
    $('.wpcf7 [type="submit"]').parent('label').removeClass('loading')
  }).on('wpcf7:mailsent', function() {
    // redirect
    var $redirect = $(this).find('[name="redirect"]')
    if ($redirect.length) {
      location.href = $redirect.val()
    }
  })
})(jQuery)



// WEBPACK FOOTER //
// ./assets/js/main.js